import { normalize, schema } from "normalizr";

// Boards are stored in a tree structure inside mongoDB.
// This function takes the tree shaped boards and returns a flat structure more suitable to a redux store.
const normalizeBoards = boards => {
  console.log("🔵 normalizeBoards INPUT:", boards);

  // Convert id to _id for normalizr compatibility (backend sends 'id', frontend expects '_id')
  // Also generate IDs for lists and cards that don't have them
  const boardsWithMongoId = boards.map(board => ({
    ...board,
    _id: board.id || board._id,
    lists: board.lists?.map((list, listIndex) => ({
      ...list,
      _id: list.id || list._id || `${board.id}-list-${listIndex}`,
      cards: list.cards?.map((card, cardIndex) => ({
        ...card,
        _id: card.id || card._id || `${board.id}-list-${listIndex}-card-${cardIndex}`
      })) || []
    })) || []
  }));

  console.log("🟢 boardsWithMongoId (after id->_id conversion):", boardsWithMongoId);

  const card = new schema.Entity("cardsById", {}, { idAttribute: "_id" });
  const list = new schema.Entity("listsById", { cards: [card] }, { idAttribute: "_id" });
  const board = new schema.Entity("boardsById", { lists: [list] }, { idAttribute: "_id" });
  const { entities } = normalize(boardsWithMongoId, [board]);

  console.log("🟣 normalizeBoards OUTPUT (entities):", entities);
  console.log("📊 Boards count:", Object.keys(entities.boardsById || {}).length);
  console.log("📋 Lists count:", Object.keys(entities.listsById || {}).length);
  console.log("🎴 Cards count:", Object.keys(entities.cardsById || {}).length);

  return entities;
};

export default normalizeBoards;
